import { render } from "./App.vue?vue&type=template&id=4e3d22e6&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4e3d22e6&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__